import styled from "@emotion/styled"
import type { Interpolation } from "@emotion/styled"
import { radiusXl, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"
import { SkeletonText } from "./SkeletonText"

interface SkeletonInputProps {
	className?: string
	inputCssRuleSet?: Interpolation<object>
	withDescription?: boolean
	withLabel?: boolean
}

export const SkeletonInput = ({ className, inputCssRuleSet, withDescription, withLabel }: SkeletonInputProps) => {
	return withLabel ? (
		<Wrapper className={className}>
			<SkeletonText $width="25%" />
			{withDescription && <DescriptionSkeletonText size="xs" $width="50%" />}
			<SkeletonInputField $inputCssRuleSet={inputCssRuleSet} />
		</Wrapper>
	) : (
		<SkeletonInputField className={className} $inputCssRuleSet={inputCssRuleSet} />
	)
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
	width: 100%;
`

const DescriptionSkeletonText = styled(SkeletonText)`
	margin: -2px 0;
`

const SkeletonInputField = styled(SkeletonComponent)<{
	$inputCssRuleSet?: Interpolation<object>
}>`
	// keep in sync with pds styles
	// https://github.com/porsche-design-system/porsche-design-system/blob/v4/packages/components/src/components/common/input-base/input-base-styles.ts#L50
	height: 3.5rem;
	border-radius: ${radiusXl};
	${({ $inputCssRuleSet }) => $inputCssRuleSet}}
`
